import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { StyledBaseButton } from '../../../styles/buttons';
import { StyledFlex } from '../../../styles/common';
import { colors, spacing } from '../../../styles/theme';
export const StyledCard = styled(Inset) `
  border-bottom: 2px solid ${colors.lightGrey};
`;
export const StyledCardButton = styled(StyledBaseButton) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: ${colors.black};
`;
export const StyledLineItem = styled(StyledFlex) `
  padding: ${spacing.medium}px 0;
  border-bottom: 1px solid ${colors.lightGrey};

  &:last-child {
    border-bottom: 0;
  }
`;
//# sourceMappingURL=subcomponents.js.map